import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import moment from 'moment'

import style from '@src/pages/Subscriptions/Subscriptions.module.scss'
import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import { Footer } from '@src/components/Footer/Footer'
import { selectUserCurrentAddresses } from '@src/store/ducks/user/selectors'
import { AppDispatch } from '@src/store/store'
import { SubscribeBlock } from '@src/components/SubscribeBlock/SubscribeBlock'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { addSubscription, closeSubscription, getSubscriptions } from '@src/store/ducks/subscriptions/thunks'
import { resetSubscriptions, setIsSuccessChangeSubscription, setSubscriptionSuccessMessage } from '@src/store/ducks/subscriptions/reducer'
import {
  selectSubscriptionsIsLoading,
  selectSubscriptionsIsLoadingChange,
  selectSubscriptionsIsSuccessChange,
  selectSubscriptionsList, selectSubscriptionsSuccessMessage,
} from '@src/store/ducks/subscriptions/selectors'
import { SubscriptionsType } from '@src/store/ducks/subscriptions/types'
import { Modal } from '@src/components/common/Modal/Modal'
import { Button } from '@src/components/Button/Button'
import { Preloader } from '@src/components/common/Preloader/Preloader'
import { setPageTitle } from '@src/store/ducks/app/reducer'
import { selectAppMessages } from '@src/store/ducks/app/selectors'

export const Subscriptions = () => {
  const dispatch = useDispatch<AppDispatch>()
  const subscriptions = useSelector(selectSubscriptionsList)
  const isSuccessChange = useSelector(selectSubscriptionsIsSuccessChange)
  const isLoadingChange = useSelector(selectSubscriptionsIsLoadingChange)
  const successMessage = useSelector(selectSubscriptionsSuccessMessage)
  const isLoading = useSelector(selectSubscriptionsIsLoading)
  const currentAddresses = useSelector(selectUserCurrentAddresses)
  const messages = useSelector(selectAppMessages)
  const [select, setSelect] = useState<SubscriptionsType | null>(null)

  useEffect(() => { dispatch(setPageTitle('Подписки')) }, [dispatch])

  useEffect(() => () => {
    dispatch(resetSubscriptions())
  }, [dispatch])

  useEffect(() => {
    if (currentAddresses) {
      dispatch(getSubscriptions(currentAddresses.accountId))
    }
  }, [currentAddresses, dispatch])

  const closeModal = useCallback(() => {
    setSelect(null)
    dispatch(setIsSuccessChangeSubscription(false))
    dispatch(setSubscriptionSuccessMessage(''))
  }, [dispatch])

  const handleChange = useCallback(() => {
    if (select) {
      if (select.isActive) {
        dispatch(closeSubscription(select.serviceId))
      } else {
        dispatch(addSubscription(select.tariffId))
      }
    }
  }, [dispatch, select])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.tariffContainer, 'container')}>
        <ReturnBtn type="secondary">Вернуться</ReturnBtn>
        <h2 className={style.mainTitle}>Подписки</h2>
        <Preloader loading={isLoading} center>
          <div className={style.subscribeBlocks}>
            {!subscriptions.length && (
              <div>Нету доступных подписок</div>
            )}
            {subscriptions.map((subscription) => (
              <SubscribeBlock
                btnName={subscription.isActive ? 'Отключить' : 'Подключить'}
                btnType={subscription.isActive ? 'secondary' : 'primary'}
                btnOutline={subscription.isActive}
                title={(
                  <div>
                    {subscription.name}
                    {!!subscription.dateEnd?.trim() && (
                      <span className={style.startDate}>
                        (действует до
                        {' '}
                        {moment(subscription.dateEnd, 'DD.MM.YYYY').format('DD.MM.YYYY')}
                        )
                      </span>
                    )}
                  </div>
                )}
                cost={subscription.price}
                btnDisabled={!!subscription.dateEnd?.trim()}
                btn
                key={subscription.id}
                btnClick={() => { setSelect(subscription) }}
                descriptionTariff={subscription.description}
              />
            ))}
          </div>
        </Preloader>
        <div className={style.descriptionBlock}>
          <span>
            Подключить домашний интернет КОСМОС Телеком.
          </span>
          <span className={style.singleDescription}>
            Подробности на сайте
            <a href="https://cosmos-telecom.by"> https://cosmos-telecom.by </a>
            или по телефону
            <a href="tel:134">
              <span className={style.phone}> 134</span>
            </a>
            .
          </span>
        </div>
      </div>
      <Footer />
      <Modal isOpen={!!select} close={closeModal}>
        {isSuccessChange ? (
          <>
            <div className={style.confirmActions}>
              {successMessage}
            </div>
          </>
        ) : (
          <>
            <div className={style.confirmActions}>
              {messages.changeTariffTitle}
            </div>
            <p>{messages.changeTariffDescription.replace('$tariff', select?.name || '')}</p>
            <div className={style.actions}>
              {select && (
                <Button
                  className={style.btnSize}
                  loading={isLoadingChange}
                  onClickFunc={() => handleChange()}
                >
                  Подтвердить
                </Button>
              )}
              <Button
                className={style.btnSize}
                disabled={isLoadingChange}
                type="textSecondary"
                onClickFunc={() => setSelect(null)}
              >
                Отменить
              </Button>
            </div>
          </>
        )}
      </Modal>
    </div>
  )
}
